import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';

import { cn } from '../../lib/utils.ts';

const ButtonRadioVerticalList = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
    return <RadioGroupPrimitive.Root className={cn('grid gap-1', className)} {...props} ref={ref} />;
});
ButtonRadioVerticalList.displayName = RadioGroupPrimitive.Root.displayName;

const ButtonRadioVerticalListItem = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Item>,
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, children, ...props }, ref) => {
    return (
        <RadioGroupPrimitive.Item
            ref={ref}
            className={cn(
                'focus-visible:ring-ring flex h-8 items-center justify-start rounded-md bg-white px-3 text-left first:rounded-l-lg focus:outline-hidden focus-visible:ring-1  disabled:cursor-not-allowed disabled:opacity-50',
                'text-sm font-medium data-[state="checked"]:bg-blue-50 data-[state="checked"]:text-blue-700',
                className,
            )}
            {...props}
        >
            {children}
        </RadioGroupPrimitive.Item>
    );
});
ButtonRadioVerticalListItem.displayName = RadioGroupPrimitive.Item.displayName;

export { ButtonRadioVerticalList, ButtonRadioVerticalListItem };
